import { Mixins, Component, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Authentication from '@/views/Authentication/models/authentication'

import PasswordInput from '@/_components/input/password/password.vue'

@Component({
    components: { PasswordInput },
})
export default class ResetPassword extends Mixins<MixinInterface>() {
    @Ref('form') readonly form!: HTMLFormElement

    // PASS VALUES
    user: any = ''
    email: any = ''
    passwordResetToken: any = ''
    invalidToken = false
    invalidCredentials = false

    // NEW PASSWORD
    password = ''
    rePassword = ''
    rePasswordVisible = false

    get rePasswordRule() {
        return () =>
            this.password === this.rePassword ||
            this.getTranslation('fe_authentication.error_password_matched')
    }

    loading = false
    valid = false

    async setPassword(event?: any) {
        event ? event.preventDefault() : null

        this.valid = this.form.validate()

        if (this.valid && !this.loading) {
            this.loading = true

            let data = {
                type: 'user',
                id: this.user,
                attributes: {
                    password: this.password,
                    passwordResetToken: this.passwordResetToken,
                },
            }

            let res = await Authentication.changePassword(data).catch(async (error) => {
                if (error.code == 'invalidToken') {
                    this.$store.commit('closeSnackbar')
                    await this.resetPassword()
                } else if (error.code == 'invalidCredentials') {
                    this.$store.commit('closeSnackbar')
                    this.invalidCredentials = true
                }
            })

            if (res) {
                let data = {
                    type: 'session',
                    attributes: {
                        signInUsername: this.email,
                        signInPassword: this.password,
                    },
                }

                await Authentication.postSession(data)
                this.$router.push({ name: 'user' })
            }

            this.loading = false
        } else {
            for (const input of this.form.inputs) {
                if (!input.valid) {
                    input.focus()
                    break
                }
            }
        }
    }

    async resetPassword() {
        if (this.email) {
            let res = await Authentication.passwordReset(this.email)

            if (res) {
                this.invalidToken = true
            }
        }
    }

    // LIFESYCLE
    async mounted() {
        this.user = this.$route.query.user
        this.passwordResetToken = this.$route.query.token
        this.email = this.$route.query.email ? this.$route.query.email : this.$route.query.username
        if (!this.user || !this.passwordResetToken) {
            this.$router.push({ name: 'sign-in' })
        }
    }
}
